import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getBackgroundColorOptions = ({
  defaultValue = "#ffffff",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "color",
  value: defaultValue,
});

export const getBorderColorOptions = ({
  defaultValue = "#000000",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "color",
  value: defaultValue,
});

export const getBorderWidthOptions = ({
  defaultValue = "1",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "slider",
  value: defaultValue,
});

export const getBorderRadiusOptions = ({
  defaultValue = {
    border_left_top_radius: "4",
    border_left_bottom_radius: "4",
    border_right_top_radius: "4",
    border_right_bottom_radius: "4",
  },
}: {
  defaultValue?: {
    border_left_top_radius: string;
    border_left_bottom_radius: string;
    border_right_top_radius: string;
    border_right_bottom_radius: string;
  };
}): StyleValue => ({
  type: "border-radius",
  value: {
    border_left_top_radius: defaultValue.border_left_top_radius,
    border_left_bottom_radius: defaultValue.border_left_bottom_radius,
    border_right_top_radius: defaultValue.border_right_top_radius,
    border_right_bottom_radius: defaultValue.border_right_bottom_radius,
  },
});
